import { useCallback } from 'react';
import useMemoryStorage, {
  getStoredState,
} from '../../../../../hooks/useMemoryStorage';
import { setupFields } from './initialState';

export default function useFields(settings) {
  const storeFields = getStoredState('simuladorRe.fields');
  const [fields, setFields] = useMemoryStorage(
    'simuladorRe.fields',
    setupFields(settings, storeFields),
    true
  );

  const updateFieldValue = useCallback(
    (key) => (value) => {
      setFields((previousFields) => {
        const field = previousFields[key];
        return { ...previousFields, [key]: { ...field, value } };
      });
    },
    [setFields]
  );

  const hideField = useCallback(
    (key) => {
      setFields((previousFields) => {
        const field = previousFields[key];
        return { ...previousFields, [key]: { ...field, isVisible: false } };
      });
    },
    [setFields]
  );

  const revealField = useCallback(
    (key) => {
      setFields((previousFields) => {
        const field = previousFields[key];
        return { ...previousFields, [key]: { ...field, isVisible: true } };
      });
    },
    [setFields]
  );

  const disableField = useCallback(
    (key) => {
      setFields((previousFields) => {
        const field = previousFields[key];
        return { ...previousFields, [key]: { ...field, isEnabled: false } };
      });
    },
    [setFields]
  );

  const enableField = useCallback(
    (key) => {
      setFields((previousFields) => {
        const field = previousFields[key];
        return { ...previousFields, [key]: { ...field, isEnabled: true } };
      });
    },
    [setFields]
  );

  return {
    fields,
    setFields,
    updateFieldValue,
    hideField,
    revealField,
    disableField,
    enableField,
  };
}
